module.exports = __webpack_public_path__ + "img/MasterCard-color.2950d7c0.svg";